import React from 'react'
import classes from './style.module.scss'
import useStyles from 'isomorphic-style-loader/useStyles'
import { FormattedMessage } from 'react-intl'
import { Iconfont } from '../../../../../../components/icon/iconfont'
import Ask from '../../../../components/ask'

export const EmptyTitle = props => {
    useStyles(classes)
    return <div className={`${classes.EmptyHead} ${classes.className}`} onClick={props?.onClick}>
        <span className={classes.Title}>
            {props.title}
        </span>
        <span className={classes.AddArea}>
            <span className={classes.Add}><FormattedMessage id="add" defaultMessage="Add"/></span>
            <Iconfont className={classes.Icon}>&#xe690;</Iconfont>
        </span>
    </div>
}

export default props => {
    useStyles(classes)
    return <div className={`${classes.Container} ${props.className}`}>
        <div className={`${classes.Hd} ${props.hdClassName}`}>
            {props.title}{' '}{props?.ask && <Ask content={props.ask}/>}
        </div>
        {props.children}
    </div>
}